export const errors: Record<string, string> = {
  CARD_3DS_DECLINED:
    '3DS validation has been rejected by the cardholder. Please try again, or use another payment method.',
  ACCOUNT_CANNOT_BE_USED:
    'Your bank informed us that this account cannot be used for this transaction. Please try with a different one, or use another payment method.',
  ACCOUNT_SEPA_NOT_SUPPORTED:
    'Unfortunately, your bank account does not support SEPA payments. Please use a different one, or try a different payment method.',
  ADDRESS_MISSING:
    'No billing address has been provided, but it is mandatory for this payment method. Please reload the page and try again.',
  ADDRESS_SHIPPING_INVALID:
    'The shipping address you provided is not valid. Please check it and try again.',
  AUTHORISATION_REVOKED:
    'The authorisation to use this payment method has been revoked or expired. Please try adding it again, or use another payment method.',
  CANNOT_BE_USED:
    'Your bank informed us that this payment method cannot be used at this time. Please try again with a different one.',
  CARD_ADDRESS_DOES_NOT_MATCH:
    "Your bank has informed us that the address you provided does not match with the card's address. Please fix it, or use another payment method.",
  CARD_CANNOT_BE_USED:
    'Unfortunately, your bank has informed us that this card cannot be used. Please contact them for more information.',
  CARD_DECLINED_TOO_MANY_TIMES:
    'Unfortunately, this card has been declined too many times. Please wait some time before trying again, or use another payment method',
  CARD_EXPIRED:
    'This card has expired. Please check the expiration date or use a different card.',
  CARD_GENERIC_DECLINE:
    'Unfortunately, your bank has declined this transaction. Please get in contact with the bank for more information, or try using a different payment method.',
  CARD_GENERIC_ERROR:
    'There was an error while using the card you provided. Please try again, or use another card or payment method.',
  CARD_INTERNAL_ERROR:
    'An error occurred while processing the card. Please try again later or with a different payment method.',
  CARD_INVALID_EXPIRATION_MONTH:
    'Your bank has informed us that the provided expiration month is not valid. Please check the card details and try again.',
  CARD_INVALID_EXPIRATION_YEAR:
    'Your bank has informed us that the provided expiration year is not valid. Please check the card details and try again.',
  CARD_INVALID_NUMBER:
    'Unfortunately, the card number you provided is incorrect. Please check it again, or use a different card.',
  CARD_INVALID_PIN:
    "The card's pin code is incorrect. Please check the card's security code or use a different card.",
  CARD_INVALID_SECURITY_CODE:
    "The card's security code is incorrect. Please check the card's security code or use a different card.",
  CARD_NOT_ENOUGH_FUNDS:
    'Your bank has informed us that your card does not have enough funds to fullfil this transaction. Please check your card limit, or use a different card or payment method.',
  CARD_POSTAL_CODE_INVALID:
    "The card's postal code is incorrect. Please double check it, or use a different card.",
  COUPON_EXPIRED:
    'The coupon code you used in this transaction is expired. Please remove it and try again.',
  DUPLICATE_TRANSACTION:
    'Your bank has informed us that an identical transaction has recently been approved. Please check your app and wait a while before trying again, or use a different payment method.',
  EMAIL_INVALID:
    'Your e-mail address is not valid. Please change it in your account settings.',
  INTERNAL_ERROR: 'An internal error has occurred.',
  PAYMENT_METHOD_TEMPORARILY_UNAVAILABLE:
    'The payment method you chose is unfortunately not available at the moment. Please use a different one, or try again later.',
  POSTAL_CODE_INVALID:
    'The postal code provided is not valid. Please check it and try again.',
  TOO_MANY_PAYMENT_REQUESTS:
    'Your bank has informed us that many payment requests were made at the same time. Please wait a little while before trying again, or use a different payment method.',
  CARD_NOT_SUPPORTED:
    'Unfortunately, the card you provided is not supported for this transaction. Please contact our Customer Support for more information, or try a different payment method.',
  CARD_DO_NOT_HONOR:
    'Unfortunately, your bank has informed us that this card is unable to honor this purchase. Please contact your bank or app for more information, or try a different payment method.',
  CARD_NOT_ENOUGH_LIMIT:
    'Unfortunately, your bank has informed us that your card does not have enough limit to fulfil this transaction. Please check your card limit, or use a different payment method.',
  CARD_ISSUER_NOT_AVAILABLE:
    'Your card issuer is unfortunately not available at the moment. Please use a different one, or try again later.',
  CARD_BLOCKED_BY_KITTL:
    'Unfortunately, this card cannot be used. Please use a different card or payment method.',
  CARD_PIN_TRIES_EXCEEDED:
    'Your bank has informed us that the allowable number of PIN tries was exceeded. Please contact the bank for more information, or try using a different payment method.',
  CARD_TRY_AGAIN:
    'Unfortunately, it is not possible to fulfil this transaction at this time. Please try again later, or use another payment method.',
  CARD_TRY_AGAIN_LATER:
    'Unfortunately, your bank has informed us that too many transaction attempts were made with this card. Please wait a while before trying again, or use a different payment method.',
};
